import { render } from "./MruResolution.vue?vue&type=template&id=7383e7a6&scoped=true"
import script from "./MruResolution.vue?vue&type=script&lang=js"
export * from "./MruResolution.vue?vue&type=script&lang=js"

import "./MruResolution.vue?vue&type=style&index=0&id=7383e7a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7383e7a6"]])

export default __exports__